// Visit stats for blog posts and SPA pitch pages, the in-app counterpart of
// public/f/track.js. The server log only sees the first page of a visit, so
// every navigation to a tracked route sends a "view" ping; video progress is
// caught by document-level listeners (media events don't bubble, but capture
// works), so videos inside the markdown HTML need no wiring. A click-to-load
// YouTube embed (iframe with a srcdoc thumbnail) counts as played when the
// iframe loads a second time, i.e. went from the thumbnail to the player;
// its progress stays unknown (that would need YouTube's third-party API).
// One GET per event to /f/ping (a one-byte file), read by stats.g1
// (ansible-celp playbook/stats/). No cookies, no storage, no third party.
import posts from './posts'

// SPA routes that are pitches rather than blog posts; also listed as
// stats_pitchwerk_routes in ansible-celp playbook/stats.yaml
const PITCHWERK = []
const BLOG = posts.map(p => p.slug)

const visit = Math.random().toString(36).slice(2, 10)
let current = null    // { slug, kind, sent } of the route being shown

function ping(ev) {
  if (!current || current.sent[ev]) return
  current.sent[ev] = true
  const url = `/f/ping?p=${encodeURIComponent(current.slug)}&k=${current.kind}&ev=${ev}&v=${visit}`
  try { fetch(url, { keepalive: true, cache: 'no-store' }) } catch (e) { /* stats only */ }
}

function onMedia(e) {
  const v = e.target
  if (v.tagName !== 'VIDEO') return
  if (e.type === 'play') ping('play')
  else if (e.type === 'ended') ping('end')
  else if (v.duration) {
    const pct = v.currentTime / v.duration * 100;
    [25, 50, 75].forEach(p => { if (pct >= p) ping(String(p)) })
  }
}

const embedLoads = new WeakMap()    // srcdoc iframe → load count

function onEmbedLoad(e) {
  const f = e.target
  if (f.tagName !== 'IFRAME' || !f.hasAttribute('srcdoc')) return
  const n = (embedLoads.get(f) || 0) + 1
  embedLoads.set(f, n)
  if (n > 1) ping('play')
}

export default function track(router) {
  ['play', 'ended', 'timeupdate'].forEach(t => document.addEventListener(t, onMedia, true))
  document.addEventListener('load', onEmbedLoad, true)
  router.afterEach(to => {
    const kind = BLOG.includes(to.name) ? 'blog' : PITCHWERK.includes(to.name) ? 'pitchwerk' : null
    current = kind ? { slug: to.name, kind, sent: {} } : null
    ping('view')
  })
}
